
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.778 19.533v-9.089A4.443 4.443 0 0019.333 6a4.443 4.443 0 00-4.444 4.444v11.112c0 1.222-1 2.222-2.222 2.222-1.223 0-2.223-1-2.223-2.222v-9.09c1.29-.466 2.223-1.688 2.223-3.133A3.329 3.329 0 009.333 6 3.329 3.329 0 006 9.333c0 1.445.933 2.667 2.222 3.134v9.089A4.443 4.443 0 0012.667 26a4.443 4.443 0 004.444-4.444V10.444c0-1.222 1-2.222 2.222-2.222 1.223 0 2.223 1 2.223 2.222v9.09A3.329 3.329 0 0022.667 26 3.329 3.329 0 0026 22.666c0-1.445-.933-2.667-2.222-3.134z"}})])
          )
        }
      }
    